import { Header } from './Header.js'
import { Footer } from './Footer.js'

import './Themes.css'

export function Themes () {
  return (
    <div>
      <Header activeItem='themes' />
      <main>
        <section className='themes-gallery'>
          <div className='container'>
            <h1>Our Themes</h1>
            <div className='themes-grid'>
              <article className='theme-card'>
                <img src='images/sunset.jpg' alt='Sunset theme' />
                <h2>Sunset</h2>
                <a href='book?theme=sunset' className='button'>
                  Book This Theme
                </a>
              </article>
              <article className='theme-card'>
                <img src='images/blue.jpg' alt='Blue theme' />
                <h2>Blue</h2>
                <a href='book?theme=blue' className='button'>
                  Book This Theme
                </a>
              </article>
              <article className='theme-card'>
                <img src='images/pink.jpg' alt='Pink theme' />
                <h2>Pink</h2>
                <a href='book?theme=pink' className='button'>
                  Book This Theme
                </a>
              </article>
              <article className='theme-card'>
                <img src='images/neutral.jpg' alt='Neutral theme' />
                <h2>Neutral</h2>
                <a href='book?theme=neutral' className='button'>
                  Book This Theme
                </a>
              </article>
              <article className='theme-card'>
                <img src='images/yellow.jpg' alt='Yellow theme' />
                <h2>Yellow</h2>
                <a href='book?theme=yellow' className='button'>
                  Book This Theme
                </a>
              </article>
            </div>
            <p className='custom-colors-note'>
              Interested in a custom color scheme? <a href='/contact'>Contact us</a> for pricing on personalized themes!
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}
